import type { CSSProperties } from 'react';

// biome-ignore lint/suspicious/noExplicitAny: items are polymorphic across call sites
type AnyData = any;

export interface StepperDotsProps {
  items: Array<AnyData>;
  selectedItem: AnyData;
  onItemChange: (item: AnyData) => void;
  keyFunc: (item: AnyData) => string;
  sx?: CSSProperties;
}

const DOT_ACTIVE: CSSProperties = {
  width: 10,
  height: 10,
  borderRadius: '50%',
  backgroundColor: '#1976d2',
  margin: '0 2px',
  cursor: 'pointer',
  border: 'none',
  padding: 0,
};

const DOT_INACTIVE: CSSProperties = {
  ...DOT_ACTIVE,
  backgroundColor: '#bdbdbd',
};

const StepperDots = ({ items, selectedItem, onItemChange, keyFunc, sx }: StepperDotsProps) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...sx,
    }}
  >
    {items.map((item) => (
      <button
        type="button"
        key={keyFunc(item)}
        aria-label="step"
        style={selectedItem === item ? DOT_ACTIVE : DOT_INACTIVE}
        onClick={() => onItemChange(item)}
      />
    ))}
  </div>
);

export default StepperDots;
